import { render, staticRenderFns } from "./SwipeGesture.vue?vue&type=template&id=20ca4c76&"
import script from "./SwipeGesture.vue?vue&type=script&lang=js&"
export * from "./SwipeGesture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports